export function getShopifyProductsByGlobalIds(data, c2s) {
  const productOrder = [];
  const variants = [];
  const shopifyProducts = [];
  let shopifyProductsInOrder = [];
  
  if (c2s) {
    data.forEach((entry) => {
      productOrder.push(entry.crossStoreProductId);
      variants.push(entry.variantId);
    });
  } else {
    data.forEach((entry) => {
      if (
        Number.isInteger(entry.crossStoreProductId) &&
        Number.isInteger(entry.variantId)
      ) {
        productOrder.push(entry.crossStoreProductId);
        variants.push(entry.variantId);
      } else {
        console.error("Expected integers");
        return;
      }
    });
  }

  const maxMatches = productOrder.length;
  let matches = 0;

  for (const shopifyProductId in window.mosmosh.productData) {
    const shopifyProduct = window.mosmosh.productData[shopifyProductId];
    if (matches > maxMatches) {
      break;
    }
    if (productOrder.includes(shopifyProduct.crossStoreProductId)) {
      shopifyProducts.push(shopifyProduct);

          //Set the size of the array
      shopifyProductsInOrder.push(null);
      matches++;
    }
    if (productOrder.includes(parseInt(shopifyProduct.crossStoreProductId))) {
      shopifyProducts.push(shopifyProduct);

      //Set the size of the array
      shopifyProductsInOrder.push(null);
      matches++;
    }
  }

  shopifyProducts.forEach((shopifyProduct) => {

    let position = productOrder.indexOf(
      parseInt(shopifyProduct.crossStoreProductId)
    );

    //Lift recommended variant up to main product
    for (const [index, variant] of shopifyProduct.variants.entries()) {
      if (parseInt(variant.sku) === variants[position]) {
        shopifyProduct.currentOrFirstVariant = variant;
        break;
      }
      //First variant if non available
      if (index === shopifyProduct.variants.length - 1) {
        shopifyProduct.currentOrFirstVariant = shopifyProduct.variants[0];
      }
    }

    //Put products is correct order
    shopifyProductsInOrder[position] = shopifyProduct;
  });

  if (productOrder.length > shopifyProducts.length) {
    //Filters out null objects, if relewise has retuned products we don't have access to
    shopifyProductsInOrder = shopifyProductsInOrder.filter(
      (value) => value !== null
    );
  }

  if (c2s) {
    shopifyProductsInOrder = shopifyProducts;
  }

  return shopifyProductsInOrder;
}
 